import api from '../config/api';

/**
 * Service para manejar compensaciones
 */
const compensacionService = {
  
  /**
   * Inicializar compensaciones para una planilla
   * Solo si no existen compensaciones previas
   * @param {number} planillaId - ID de la planilla
   * @param {Array} empleadosIds - Array de IDs de empleados
   * @returns {Promise} - Respuesta del servidor
   */
  async inicializarCompensacionesPlanilla(planillaId, empleadosIds) {
    try {
      console.log(`💤 Inicializando compensaciones para planilla ${planillaId} con ${empleadosIds.length} empleados`);
      
      const response = await api.post('/compensaciones/inicializar', {
        planilla_id: planillaId,
        empleados_ids: empleadosIds
      });

      if (response.data.success) {
        const { data } = response.data;
        console.log(`✅ Compensaciones ${data.accion}: ${data.compensaciones_creadas || data.compensaciones_existentes} registros`);
        
        return {
          success: true,
          data: data,
          message: response.data.message
        };
      } else {
        console.error('❌ Error en la respuesta del servidor:', response.data);
        return {
          success: false,
          error: response.data.message || 'Error desconocido'
        };
      }

    } catch (error) {
      console.error('❌ Error al inicializar compensaciones:', error);
      
      if (error.response && error.response.data) {
        return {
          success: false,
          error: error.response.data.message || 'Error del servidor',
          details: error.response.data.errors || null
        };
      }
      
      return {
        success: false,
        error: error.message || 'Error de conexión'
      };
    }
  },

  /**
   * Obtener compensaciones de una planilla
   * @param {number} planillaId - ID de la planilla
   * @returns {Promise} - Lista de compensaciones
   */
  async obtenerCompensacionesPorPlanilla(planillaId) {
    try {
      console.log(`📊 Obteniendo compensaciones para planilla ${planillaId}`);
      
      const response = await api.get(`/compensaciones/planilla/${planillaId}`);

      if (response.data.success) {
        console.log(`✅ Compensaciones obtenidas: ${response.data.total} registros`);
        return {
          success: true,
          data: response.data.data,
          total: response.data.total,
          totalHoras: response.data.total_horas
        };
      } else {
        return {
          success: false,
          error: response.data.message || 'Error al obtener compensaciones'
        };
      }

    } catch (error) {
      console.error('❌ Error al obtener compensaciones:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Error de conexión'
      };
    }
  },

  /**
   * Actualizar horas compensadas de una compensación específica
   * @param {number} compensacionId - ID de la compensación
   * @param {number} horasCompensadas - Nuevas horas compensadas
   * @returns {Promise} - Compensación actualizada
   */
  async actualizarHorasCompensadas(compensacionId, horasCompensadas) {
    try {
      console.log(`⏰ Actualizando compensación ${compensacionId} con ${horasCompensadas} horas`);
      
      const response = await api.put(`/compensaciones/${compensacionId}/horas`, {
        horas_compensadas: horasCompensadas
      });

      if (response.data.success) {
        console.log(`✅ Compensación actualizada correctamente`);
        return {
          success: true,
          data: response.data.data,
          message: response.data.message
        };
      } else {
        return {
          success: false,
          error: response.data.message || 'Error al actualizar compensación'
        };
      }

    } catch (error) {
      console.error('❌ Error al actualizar compensación:', error);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Error de conexión'
      };
    }
  }
};

export default compensacionService; 